import {FileSpreadsheet, BarChart3, FileText} from 'lucide-react'
import { useState } from 'react'
import PaymentModal from './PaymentModal'

function Pricing() {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const items = [
    { icon: FileSpreadsheet, text: 'Файл "Планер Намерений" (Excel)' },
    { icon: BarChart3, text: "Трекер привычек (Бонус)" },
    { icon: FileText, text: "Инструкция по внедрению (Бонус)" },
  ]

  return (
    <section id="pricing" className="py-16 sm:py-24 px-4 sm:px-6 lg:px-8 bg-gray-50 fade-on-scroll opacity-0">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-center text-black mb-12 sm:mb-16 uppercase">
          КОМПЛЕКТ ДИСЦИПЛИНЫ:
        </h2>

        <div className="bg-white rounded-2xl shadow-2xl p-8 sm:p-12 border-4 border-[#1E2B3C]">
          {/* Список комплекта */}
          <div className="space-y-5 mb-10 sm:mb-12">
            {items.map((item, index) => (
              <div key={index} className="flex items-center gap-4">
                <item.icon className="w-8 h-8 text-[#F45B3C] flex-shrink-0" strokeWidth={2} />
                <span className="text-lg sm:text-xl text-gray-800 font-medium">
                  {item.text}
                </span>
              </div>
            ))}
          </div>

          {/* Цена */}
          <div className="text-center space-y-4 mb-8 sm:mb-10">
            <div className="text-2xl sm:text-3xl text-gray-400 line-through font-semibold">
              1490 ₽
            </div>
            <div className="text-5xl sm:text-6xl lg:text-7xl font-black text-[#F45B3C]">
              590 ₽
            </div>
            <p className="text-base sm:text-lg text-gray-600 italic max-w-md mx-auto">
              Стоимость одного часа вашей работы. Инвестируйте час, чтобы сэкономить сотни.
            </p>
          </div>

          {/* Кнопка */}
          <button
            onClick={() => setIsModalOpen(true)}
            className="w-full bg-[#F45B3C] text-white font-black px-8 py-5 sm:py-6 rounded-lg text-xl sm:text-2xl hover:bg-[#D32F2F] transition-all duration-200 hover:shadow-2xl hover:-translate-y-1 shadow-lg uppercase"
          >
            ЗАБРАТЬ ПЛАНЕР
          </button>
        </div>
      </div>

      <PaymentModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  )
}

export default Pricing
